<template>
  <Carousel autoplay :autoplay-speed="autoplaySpeed" v-model="value2" loop>
    <CarouselItem v-for="item in carouselData" :key="item.id">
      <div class="demo-carousel" :style="{background:'url('+item.img+') no-repeat',backgroundSize: 'cover'}"></div>
    </CarouselItem>
  </Carousel>
</template>
<script>
import carousel_01 from '../assets/carousel_01.png'
import carousel_02 from '../assets/carousel_02.png'
import carousel_03 from '../assets/carousel_03.png'
import m_carousel_01 from '../assets/m_banner1.png'
import m_carousel_02 from '../assets/m_banner2.png'
import m_carousel_03 from '../assets/m_banner3.png'
var carouselSource = [{
  id: 1,
  theme: '嘉信与您一起同行',
  img: carousel_01
}, {
  id: 2,
  theme: '保险让生活更美好',
  img: carousel_02
}, {
  id: 3,
  theme: '平台更高，视野更广',
  img: carousel_03
}]
var carouselSource_m = [{
  id: 1,
  theme: '嘉信与您一起同行',
  img: m_carousel_01
}, {
  id: 2,
  theme: '保险让生活更美好',
  img: m_carousel_02
}, {
  id: 3,
  theme: '平台更高，视野更广',
  img: m_carousel_03
}]

export default {
  data() {
    return {
      value2: 0,
      autoplaySpeed: 5000,
      carouselData: []
    }
  },
  mounted: function () {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.carouselData = carouselSource_m;
    } else {
      this.carouselData = carouselSource;
    }
  }
}
</script>
<style scoped lang="less" >
@media screen and (min-width: 768px) {
  .demo-carousel {
    width: 100%;
    height: 400px;
  }
}
@media screen and (max-width: 767px) {
  .demo-carousel {
    width: 100%;
    height: 200px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue